import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { User } from '@shared/models/User';

@Component({
    selector: 'app-user-display',
    template: `
    <span [title]="userId">
      {{ displayName }}
    </span>
  `
})
export class UserDisplayComponent implements OnChanges {
    @Input() userId: string | undefined;
    @Input() users: User[] = [];
    @Input() showId: boolean = false;

    displayName: string = '';

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['userId'] || changes['users']) {
            this.resolveName();
        }
    }

    private resolveName() {
        if (!this.userId) {
            this.displayName = 'Unknown';
            return;
        }
        if (!this.users || this.users.length === 0) {
            this.displayName = this.userId;
            return;
        }

        const user = this.users.find(u => u.username === this.userId || u._id === this.userId);
        if (user) {
            const name = [user.firstName, user.lastName].filter(v => !!v).join(' ');
            this.displayName = name ? (this.showId ? `${name} (${user.username})` : name) : user.username;
        } else {
            this.displayName = this.userId;
        }
    }
}
